import React, { useState,useEffect } from "react";
import { useDispatch } from "react-redux";
import { FaRegPlayCircle } from "react-icons/fa";
import { AiOutlineDelete } from "react-icons/ai";
import GalleryLibraryModal from "./GalleryLibraryModal";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const GalleryPickerField = ({
    label,
    church,
    rowData,
    name,
    handleChange,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);




  // Handle selection coming from modal: we expect normalized video object
  const handleImageSelect = (imgSet) => {
        const normalized = {
      id: imgSet.id ?? imgSet._id ?? imgSet.fullItem?._id,
      videoName: imgSet.videoName ?? imgSet.fullItem?.videoName ?? imgSet.name,
      videoDescription: imgSet.videoDescription ?? imgSet.fullItem?.videoDescription ?? "",
      youtubeurl: imgSet.youtubeurl ?? imgSet.fullItem?.youtubeurl ?? "",
      thumbnailId: imgSet.thumbnailId ?? imgSet.fullItem?.gallery?._id ?? imgSet.tumbnailGalleryObjId ?? null,
      thumbnailUrl: imgSet.thumbnailUrl ?? imgSet.fullItem?.gallery?.imageUrl ?? imgSet.url ?? "",
      thumbnailName: imgSet.thumbnailName ?? imgSet.fullItem?.gallery?.imageName ?? imgSet.name ?? "",
      galleryId: imgSet.galleryId ?? imgSet.fullItem?.gallery?._id ?? null,
      fullItem: imgSet.fullItem ?? imgSet,
    };

    if (!selectedImages.some((i) => i.id === normalized.id)) {
      const updated = [...selectedImages, normalized];
      setSelectedImages(updated);

      if (typeof handleChange === "function") {
        handleChange({ target: { name, value: updated } });
      }

      // Only auto-save if explicitly enabled

    }
    setShowModal(false);
  };

  // Delete handler adapted for normalized object
  const handleDeleted = (imgSet, index) => {

            const updated = selectedImages.filter((_, i) => i !== index);
      setSelectedImages(updated);
      if (typeof handleChange === "function") {
        handleChange({ target: { name, value: updated } });
      }
      toast.info("Item removed locally.");
      return;
    }






  return (
    <div className="flex flex-col gap-2 my-4 w-full max-w-[99%] ">
      <div className="flex items-center justify-between">
        <label className="text-[12px] text-greyish font-medium">{label}</label>
        <button
          onClick={() => setShowModal(true)}
          className="text-white hover:text-gray-300 flex items-center"
        >
          <FaRegPlayCircle size={18} className="mr-2" /> Select Video
        </button>
      </div>

      {/* Selected items */}
      <div className="bg-[#1b1b1b] border border-[#333] rounded-lg p-3 w-full flex flex-col gap-2">
        {selectedImages.length > 0 ? (
          selectedImages.map((imgSet, index) => (
            <div
              key={imgSet.id || index}
              className="flex items-center justify-between bg-[#131313] border border-[#333] rounded-lg px-3 py-2"
            >
              <div className="flex items-center gap-3">
                {/* Video icon + name (Option 2) */}
                <FaRegPlayCircle className="text-white w-5 h-5" />
                <span className="text-white text-sm font-medium truncate">
                  {imgSet.videoName || imgSet.thumbnailName || imgSet.name || "Untitled"}
                </span>
              </div>
              <button
                onClick={() => handleDeleted(imgSet, index)}
                className="text-white hover:text-red-500 rounded-full p-1"
              >
                <AiOutlineDelete size={18} />
              </button>
            </div>
          ))
        ) : (
          <span className="text-greyish text-sm">No video selected</span>
        )}
      </div>

      {/* Modal */}
      {showModal && church?._id && (
        <GalleryLibraryModal
          isOpen={showModal}
          onClose={() => setShowModal(false)}
          church={church}
          handleGallerySelect={handleImageSelect}
        />
      )}
    </div>
  );
};

export default GalleryPickerField;